// Mock Automation data for Max OS Cloud — Advanced Automation Builder

export const NODE_TYPES = {
  TRIGGER: 'trigger',
  CONDITION: 'condition',
  ACTION: 'action',
  LOGIC: 'logic',
  AI: 'ai',
  END: 'end',
};

export const NODE_CATEGORIES = {
  trigger: {
    label: 'Triggers',
    color: 'amber',
    border: 'border-amber-500/50',
    bg: 'bg-amber-500/10',
    text: 'text-amber-400',
    dot: 'bg-amber-500',
    items: [
      { type: 'trigger', subtype: 'new_message', label: 'New Message Received', icon: 'MessageSquare' },
      { type: 'trigger', subtype: 'scheduled', label: 'Scheduled Time (Cron)', icon: 'Clock' },
      { type: 'trigger', subtype: 'webhook', label: 'Webhook Received', icon: 'Webhook' },
      { type: 'trigger', subtype: 'form_submit', label: 'Form Submitted', icon: 'FileText' },
      { type: 'trigger', subtype: 'agent_idle', label: 'Agent Idle', icon: 'Bot' },
      { type: 'trigger', subtype: 'email_received', label: 'Email Received', icon: 'Mail' },
    ],
  },
  action: {
    label: 'Actions',
    color: 'emerald',
    border: 'border-emerald-500/50',
    bg: 'bg-emerald-500/10',
    text: 'text-emerald-400',
    dot: 'bg-emerald-500',
    items: [
      { type: 'action', subtype: 'send_message', label: 'Send Message', icon: 'Send' },
      { type: 'action', subtype: 'send_email', label: 'Send Email', icon: 'Mail' },
      { type: 'action', subtype: 'send_slack', label: 'Send Slack Message', icon: 'MessageSquare' },
      { type: 'action', subtype: 'call_webhook', label: 'Call Webhook', icon: 'Webhook' },
      { type: 'action', subtype: 'http_request', label: 'HTTP Request', icon: 'Globe' },
      { type: 'action', subtype: 'update_crm', label: 'Update CRM', icon: 'Database' },
      { type: 'action', subtype: 'db_query', label: 'Database Query', icon: 'Database' },
      { type: 'action', subtype: 'assign_human', label: 'Assign to Human', icon: 'UserPlus' },
      { type: 'action', subtype: 'wait', label: 'Wait / Delay', icon: 'Timer' },
    ],
  },
  condition: {
    label: 'Conditions',
    color: 'sky',
    border: 'border-sky-500/50',
    bg: 'bg-sky-500/10',
    text: 'text-sky-400',
    dot: 'bg-sky-500',
    items: [
      { type: 'condition', subtype: 'keyword', label: 'If Message Contains Keyword', icon: 'Search' },
      { type: 'condition', subtype: 'user_type', label: 'If User is New/Returning', icon: 'Users' },
      { type: 'condition', subtype: 'business_hours', label: 'If Time is Business Hours', icon: 'Sun' },
      { type: 'condition', subtype: 'channel', label: 'If Channel is WhatsApp/Telegram/Email', icon: 'Globe' },
    ],
  },
  logic: {
    label: 'Logic',
    color: 'violet',
    border: 'border-violet-500/50',
    bg: 'bg-violet-500/10',
    text: 'text-violet-400',
    dot: 'bg-violet-500',
    items: [
      { type: 'logic', subtype: 'condition', label: 'Condition (If/Else)', icon: 'GitBranch' },
      { type: 'logic', subtype: 'delay', label: 'Delay', icon: 'Timer' },
      { type: 'logic', subtype: 'loop', label: 'Loop', icon: 'RefreshCw' },
      { type: 'logic', subtype: 'switch', label: 'Switch (Multi-Branch)', icon: 'GitBranch' },
    ],
  },
  ai: {
    label: 'AI',
    color: 'fuchsia',
    border: 'border-fuchsia-500/50',
    bg: 'bg-fuchsia-500/10',
    text: 'text-fuchsia-400',
    dot: 'bg-fuchsia-500',
    items: [
      { type: 'ai', subtype: 'ai_text_gen', label: 'AI Text Generation', icon: 'Sparkles' },
      { type: 'ai', subtype: 'ai_classify', label: 'AI Classification', icon: 'Tags' },
      { type: 'ai', subtype: 'ai_summarize', label: 'AI Summarization', icon: 'FileText' },
    ],
  },
  end: {
    label: 'End',
    color: 'red',
    border: 'border-red-500/50',
    bg: 'bg-red-500/10',
    text: 'text-red-400',
    dot: 'bg-red-500',
    items: [
      { type: 'end', subtype: 'end_flow', label: 'End Flow', icon: 'StopCircle' },
    ],
  },
};

// Helper to create a node
function n(id, type, subtype, label, x, y, config = {}) {
  return { id, type, subtype, label, x, y, config };
}

// Helper to create a connection
function c(from, to, label = '') {
  return { from, to, label };
}

// ─── Mock Automation 1: Auto-reply to FAQs ───
const autoReplyFAQ = {
  id: 'auto-001',
  name: 'Auto-reply to FAQs',
  description: 'Automatically respond to frequently asked questions with predefined answers',
  status: 'active',
  createdAt: Date.now() - 7 * 86400000,
  updatedAt: Date.now() - 2 * 86400000,
  nodes: [
    n('n1', 'trigger', 'new_message', 'New Message Received', 100, 100, { channel: 'any' }),
    n('n2', 'condition', 'keyword', 'If Message Contains Keyword', 320, 100, { keywords: ['pricing', 'price', 'cost', 'how much'] }),
    n('n3', 'action', 'send_message', 'Send Message', 540, 50, { message: 'Our plans start at $297/mo. Check maxemployee.com/pricing for details.' }),
    n('n4', 'condition', 'keyword', 'If Message Contains Keyword', 540, 180, { keywords: ['help', 'support', 'issue'] }),
    n('n5', 'action', 'send_message', 'Send Message', 760, 130, { message: 'Our support team will assist you shortly. Please describe your issue.' }),
    n('n6', 'end', 'end_flow', 'End Flow', 960, 100, {}),
  ],
  connections: [
    c('n1', 'n2'),
    c('n2', 'n3', 'Yes'),
    c('n2', 'n4', 'No'),
    c('n3', 'n6'),
    c('n4', 'n5', 'Yes'),
    c('n4', 'n6', 'No'),
    c('n5', 'n6'),
  ],
};

// ─── Mock Automation 2: Escalate After Hours ───
const escalateAfterHours = {
  id: 'auto-002',
  name: 'Escalate After Hours',
  description: 'Route messages to on-call team when outside business hours',
  status: 'active',
  createdAt: Date.now() - 5 * 86400000,
  updatedAt: Date.now() - 1 * 86400000,
  nodes: [
    n('n1', 'trigger', 'new_message', 'New Message Received', 100, 120, { channel: 'any' }),
    n('n2', 'condition', 'business_hours', 'If Time is Business Hours', 340, 120, { startHour: 9, endHour: 18, timezone: 'America/New_York' }),
    n('n3', 'action', 'send_message', 'Send Message', 580, 60, { message: 'Thanks for your message! We are currently offline. An on-call agent will respond first thing in the morning.' }),
    n('n4', 'action', 'assign_human', 'Assign to Human', 580, 200, { team: 'on-call', priority: 'normal' }),
    n('n5', 'end', 'end_flow', 'End Flow', 800, 130, {}),
  ],
  connections: [
    c('n1', 'n2'),
    c('n2', 'n3', 'No'),
    c('n2', 'n4', 'Yes'),
    c('n3', 'n5'),
    c('n4', 'n5'),
  ],
};

// ─── Mock Automation 3: Welcome New Users ───
const welcomeNewUsers = {
  id: 'auto-003',
  name: 'Welcome New Users',
  description: 'Send a welcome sequence to new users after signup',
  status: 'active',
  createdAt: Date.now() - 10 * 86400000,
  updatedAt: Date.now() - 3 * 86400000,
  nodes: [
    n('n1', 'trigger', 'form_submit', 'Form Submitted', 100, 100, { form: 'signup' }),
    n('n2', 'condition', 'user_type', 'If User is New/Returning', 340, 100, { check: 'is_new' }),
    n('n3', 'action', 'send_email', 'Send Email', 580, 50, { template: 'welcome', subject: 'Welcome to Max OS Cloud!' }),
    n('n4', 'action', 'wait', 'Wait / Delay', 760, 50, { duration: '24h' }),
    n('n5', 'action', 'send_message', 'Send Message', 940, 50, { message: 'Hi! Have you had a chance to set up your first agent? We are here to help!' }),
    n('n6', 'end', 'end_flow', 'End Flow', 1120, 100, {}),
  ],
  connections: [
    c('n1', 'n2'),
    c('n2', 'n3', 'New'),
    c('n2', 'n6', 'Returning'),
    c('n3', 'n4'),
    c('n4', 'n5'),
    c('n5', 'n6'),
  ],
};

// ─── Mock Automation 4: Webhook to CRM Sync ───
const webhookToCrm = {
  id: 'auto-004',
  name: 'Webhook to CRM Sync',
  description: 'Sync incoming webhook data to CRM and notify sales team',
  status: 'paused',
  createdAt: Date.now() - 3 * 86400000,
  updatedAt: Date.now() - 1 * 86400000,
  nodes: [
    n('n1', 'trigger', 'webhook', 'Webhook Received', 100, 100, { endpoint: '/api/webhooks/crm' }),
    n('n2', 'action', 'update_crm', 'Update CRM', 340, 100, { object: 'lead', action: 'upsert' }),
    n('n3', 'action', 'send_email', 'Send Email', 560, 100, { template: 'new_lead', to: 'sales@maxemployee.com' }),
    n('n4', 'end', 'end_flow', 'End Flow', 760, 100, {}),
  ],
  connections: [
    c('n1', 'n2'),
    c('n2', 'n3'),
    c('n3', 'n4'),
  ],
};

// ─── Mock Automation 5: Scheduled Report ───
const scheduledReport = {
  id: 'auto-005',
  name: 'Daily Analytics Report',
  description: 'Send daily analytics summary to team every morning at 9am',
  status: 'active',
  createdAt: Date.now() - 14 * 86400000,
  updatedAt: Date.now() - 6 * 86400000,
  nodes: [
    n('n1', 'trigger', 'scheduled', 'Scheduled Time (Cron)', 100, 100, { cron: '0 9 * * *', timezone: 'America/New_York' }),
    n('n2', 'action', 'call_webhook', 'Call Webhook', 320, 100, { url: '/api/analytics/daily', method: 'GET' }),
    n('n3', 'condition', 'keyword', 'If Message Contains Keyword', 540, 100, { check: 'has_data' }),
    n('n4', 'action', 'send_email', 'Send Email', 760, 50, { template: 'daily_report', to: 'team@maxemployee.com' }),
    n('n5', 'action', 'send_message', 'Send Message', 760, 180, { message: 'No analytics data available for today.' }),
    n('n6', 'end', 'end_flow', 'End Flow', 960, 110, {}),
  ],
  connections: [
    c('n1', 'n2'),
    c('n2', 'n3'),
    c('n3', 'n4', 'Has Data'),
    c('n3', 'n5', 'No Data'),
    c('n4', 'n6'),
    c('n5', 'n6'),
  ],
};

export const mockAutomations = [
  autoReplyFAQ,
  escalateAfterHours,
  welcomeNewUsers,
  webhookToCrm,
  scheduledReport,
];

// ─── CRUD helpers (in-memory + localStorage) ───

const STORAGE_KEY = 'max_automations';

export function loadAutomations() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (e) {
    // ignore
  }
  // First load — seed with mock data
  saveAutomations(mockAutomations);
  return mockAutomations;
}

export function saveAutomations(automations) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(automations));
  } catch (e) {
    // ignore
  }
  return automations;
}

export function getAutomationById(id) {
  const automations = loadAutomations();
  return automations.find(a => a.id === id) || null;
}

export function createAutomation(data) {
  const automations = loadAutomations();
  const newAuto = {
    ...data,
    id: `auto-${String(automations.length + 1).padStart(3, '0')}`,
    status: 'active',
    createdAt: Date.now(),
    updatedAt: Date.now(),
    nodes: data.nodes || [],
    connections: data.connections || [],
  };
  automations.push(newAuto);
  saveAutomations(automations);
  return newAuto;
}

export function updateAutomation(id, updates) {
  const automations = loadAutomations();
  const idx = automations.findIndex(a => a.id === id);
  if (idx === -1) return null;
  automations[idx] = { ...automations[idx], ...updates, updatedAt: Date.now() };
  saveAutomations(automations);
  return automations[idx];
}

export function deleteAutomation(id) {
  const automations = loadAutomations();
  const idx = automations.findIndex(a => a.id === id);
  if (idx === -1) return false;
  automations.splice(idx, 1);
  saveAutomations(automations);
  return true;
}

// ─── Flow validation ───

export function validateFlow(nodes, connections) {
  const errors = [];

  if (!nodes || nodes.length === 0) {
    errors.push('Flow must have at least one node');
    return { valid: false, errors };
  }

  // Check for at least one trigger
  const hasTrigger = nodes.some(n => n.type === 'trigger');
  if (!hasTrigger) {
    errors.push('Flow must have at least one Trigger node');
  }

  // Check for at least one end
  const hasEnd = nodes.some(n => n.type === 'end');
  if (!hasEnd) {
    errors.push('Flow must have at least one End node');
  }

  // Check for cycles using DFS
  if (connections && connections.length > 0) {
    const adj = {};
    nodes.forEach(n => { adj[n.id] = []; });
    connections.forEach(c => {
      if (adj[c.from]) adj[c.from].push(c.to);
    });

    const visited = new Set();
    const recStack = new Set();

    function hasCycle(nodeId) {
      visited.add(nodeId);
      recStack.add(nodeId);
      for (const neighbor of (adj[nodeId] || [])) {
        if (!visited.has(neighbor)) {
          if (hasCycle(neighbor)) return true;
        } else if (recStack.has(neighbor)) {
          return true;
        }
      }
      recStack.delete(nodeId);
      return false;
    }

    for (const nodeId of Object.keys(adj)) {
      if (!visited.has(nodeId)) {
        if (hasCycle(nodeId)) {
          errors.push('Flow contains a cycle — circular connections are not allowed');
          break;
        }
      }
    }
  }

  // Check all nodes are connected (no orphans)
  if (connections && connections.length > 0) {
    const connectedNodes = new Set();
    connections.forEach(c => {
      connectedNodes.add(c.from);
      connectedNodes.add(c.to);
    });
    const orphanNodes = nodes.filter(n => !connectedNodes.has(n.id));
    if (orphanNodes.length > 0) {
      errors.push(`${orphanNodes.length} node(s) are not connected to the flow`);
    }
  }

  return { valid: errors.length === 0, errors };
}

// ─── Flow simulation (mock execution) ───

export function simulateFlow(automation) {
  const steps = [];
  const { nodes, connections } = automation;

  if (!nodes || nodes.length === 0) {
    return [{ type: 'error', message: 'No nodes in flow', timestamp: Date.now() }];
  }

  // Find trigger nodes
  const triggers = nodes.filter(n => n.type === 'trigger');
  if (triggers.length === 0) {
    return [{ type: 'error', message: 'No trigger node found', timestamp: Date.now() }];
  }

  steps.push({
    type: 'start',
    message: `Starting flow: ${automation.name}`,
    timestamp: Date.now(),
  });

  // Build adjacency
  const adj = {};
  nodes.forEach(n => { adj[n.id] = []; });
  connections.forEach(c => {
    if (adj[c.from]) adj[c.from].push({ to: c.to, label: c.label });
  });

  // Simple BFS traversal from first trigger
  const visited = new Set();
  const queue = [triggers[0].id];

  while (queue.length > 0) {
    const nodeId = queue.shift();
    if (visited.has(nodeId)) continue;
    visited.add(nodeId);

    const node = nodes.find(n => n.id === nodeId);
    if (!node) continue;

    const nodeTypeLabel = node.type.charAt(0).toUpperCase() + node.type.slice(1);
    steps.push({
      type: node.type,
      nodeId: node.id,
      message: `[${nodeTypeLabel}] ${node.label}`,
      timestamp: Date.now() + steps.length * 100,
    });

    const neighbors = adj[nodeId] || [];
    for (const neighbor of neighbors) {
      if (!visited.has(neighbor.to)) {
        if (neighbor.label) {
          steps.push({
            type: 'branch',
            message: `Branch: ${neighbor.label}`,
            timestamp: Date.now() + steps.length * 100,
          });
        }
        queue.push(neighbor.to);
      }
    }
  }

  steps.push({
    type: 'complete',
    message: 'Flow execution completed successfully',
    timestamp: Date.now() + steps.length * 100,
  });

  return steps;
}
